export default __webpack_public_path__ + "static/media/05.e95bfd0a.webp";